// extracted by mini-css-extract-plugin
module.exports = {"mappedAnnounces":"PaginationScroll-module--mappedAnnounces--1IH9k"};